<template>
  <div class="edit-password-page">


    <div class="page-form">
    
      <div class="form-item " v-show="isSetPassword" >
        <div class="label" v-show="isSetPassword">{{$t('editSafePassword.label1')}}</div>
        <div class="input">
          <input :type="showOldPassword ? 'text' : 'password'" inputmode="decimal" v-model="form.oldPassword" :placeholder="i18n.t('editSafePassword.labelPlaceholder1')"/>
          <div class="adot" @click="changeShowOldPassword">
            <img :src="showOldPassword ? eyeUrl2 : eyeUrl" alt="" >
          </div>
        </div>
      </div>
    
      <div class="form-item" id="passwordDom">
        <div class="label">{{$t('editSafePassword.label2')}}</div>
        <div class="input">
          <input :type="showPassword ? 'text' : 'password'" inputmode="decimal" v-model="form.password" :placeholder="i18n.t('editSafePassword.labelPlaceholder2')"/>
          <div class="adot"  @click="changeShowPassword">
            <img :src="showPassword ? eyeUrl2 : eyeUrl" alt="">
          </div>
        </div>
      </div>

      <div class="form-item" >
        <div class="label">{{$t('editSafePassword.label3')}}</div>
        <div class="input">
          <input :type="showPassword2 ? 'text' : 'password'" inputmode="decimal"  v-model="form.password2" :placeholder="i18n.t('editSafePassword.labelPlaceholder3')"/>
          <div class="adot" @click="changeshowPassword2">
            <img :src="showPassword2 ? eyeUrl2 : eyeUrl" alt="" >
          </div>
        </div>
      </div>

      <div class="form-item" v-if="captchaEnabled && userPhone && userEmail">
        <div class="label">{{$t('editSafePassword.label4')}}</div>
        <div class="input">
          <a-select v-model="form.codeType"  dropdownClassName="full-select" class="hide-border">
            <img :src="downUrl" slot="suffixIcon" class="suffix-icon">
            <a-select-option v-for="(child, index) in typeList" :key="index" :value="child.value" >
              {{child.text}}
            </a-select-option>
          </a-select>
        </div>
      </div>

      <div class="form-item " v-if="captchaEnabled" >
        <div class="label">{{$t('editPassword.label4')}}</div>
        <div class="input"> 
          <input type="number" inputmode="decimal"  v-model="form.code" :placeholder="i18n.t('editPassword.labelPlaceholder4')">
          <div class="adot long" >
            <span class="gray" v-if="isDisabled">{{$t('editPassword.resend')}}({{timeCount}})</span>
            <span v-else @click="resend">{{$t('editPassword.send')}}</span>
          </div>
        </div>
      </div>

      <div class="btn">
        <Button class="login-btn" @click="submit"  :class="btnDisabled ? 'gray' : ''">{{i18n.t(`editSafePassword.btn`)}}</Button>
      </div>
    </div>


  </div>
</template>
<script>
  import { Button, Popup } from 'vant'
  import { configList, userInfo } from '@/api/user'
  import { sendAuthCode, sendAuthSms } from '@/api/login'
  import { editSafePassword,CheckPassword } from '@/api/setting'
  import { isCaptchaEnabled, normalizeCaptchaEnable } from '@/utils/captcha'
  export default {
    components: {
      Button,
      Popup,
    },
    data() {
      return {
        form: {
          oldPassword: '',
          password: '',
          password2: '',
          code: '',
          codeType: 'email'
        },
        // 是否设置密码
        isDisabled: false,
        isSetPassword: false,
        eyeUrl: require('../../assets/imgs/icon-eye.png'),
        eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
        downUrl: require('../../assets/imgs/icon-arrow-down2.png'),
        showPassword: false,
        showPassword2: false,
        showOldPassword: false,
        passwordAuthList: [],
        userEmail: '',
        userPhone: '',
        sendTime: '',
        captchaReady: false,
        typeList: [
          {
            value: 'email',
            text: this.$t('editSafePassword.type1'),
          },
          {
            value: 'phone',
            text: this.$t('editSafePassword.type2'),
          },
        ],
      }
    },
    computed: {
      captchaEnabled() {
        return isCaptchaEnabled(this.$store.state.captchaEnable, this.captchaReady)
      },
      btnDisabled() {
        if (!this.captchaReady) {
          return true
        }

        // 如果验证码关闭,不需要验证码
        if (!this.captchaEnabled) {
          if (this.isSetPassword) {
            return !(this.form.password && this.form.password2 && this.form.oldPassword)
          } else {
            return !(this.form.password && this.form.password2)
          }
        }
        
        if (this.isSetPassword) {
          return !(this.form.password && this.form.password2 && this.form.oldPassword && this.form.code)
        } else {
          return !(this.form.password && this.form.password2 && this.form.code)
        }
      },
      timeCount() {
        return this.sendTime + 's'
      },
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.syncCaptchaConfig()

        CheckPassword().then(res => {
          if (res.code === 0) {
            this.isSetPassword = true
          } else {
            this.isSetPassword = false
          }
        })


        userInfo().then(res => {
          this.userPhone = res.data.Phone 
          this.userEmail = res.data.Email
        })
      },
      syncCaptchaConfig() {
        configList().then(res => {
          if (res && res.captcha_enable !== undefined) {
            this.$store.state.captchaEnable = normalizeCaptchaEnable(res.captcha_enable.Value)
          }
        }).catch(() => {}).then(() => {
          this.captchaReady = true
        })
      },
      back() {
        this.$router.go(-1)
      },
      toLogin() {
        this.$router.push({
          name: 'login'
        })
      },
      submit() {
        if (!this.captchaReady) {
          return
        }

        if(this.isSetPassword) {
          if (!this.form.oldPassword) {
            this.$toast.fail( this.i18n.t('editSafePassword.labelPlaceholder1'))
            return
          }
        }

        if (!this.form.password) {
          this.$toast.fail( this.i18n.t('editSafePassword.labelPlaceholder2'))
          return
        }
        if (!this.form.password2) {
          this.$toast.fail(this.i18n.t('editSafePassword.labelPlaceholder3'))
          return
        }

        let form = new FormData()
        form.append('OldPassword', this.form.oldPassword)
        form.append('NewPassword', this.form.password)
        form.append('ConfirmPassword', this.form.password2)
        form.append('Code', this.form.code)
        editSafePassword(form).then(res => {
          if (res.code == 0) {
            this.$toast.success(this.i18n.t('editSafePassword.success'))
            // 清空表单
            this.form = {
              oldPassword: '',
              password: '',
              password2: '',
              code: ''
            }
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      changeShowOldPassword() {
        this.showOldPassword = !this.showOldPassword
      },
      changeShowPassword() {
        this.showPassword = !this.showPassword
      },
      changeshowPassword2() {
        this.showPassword2 = !this.showPassword2
      },
      resend() {
        if (!this.captchaEnabled || this.isDisabled) {
          return
        } 
        if (this.userPhone && this.userEmail) {
          if (this.form.codeType == 'email') {
            this.sendEmail()
          } else {
            this.sendPhoneSms()
          }
        } else {
          if (this.userEmail) {
            this.sendEmail()
          } else {
            this.sendPhoneSms()
          } 
        }
      },
      sendPhoneSms(){
        let form = new FormData()
        form.append('Phone', this.userPhone)
        form.append('Type', 6)
        sendAuthSms(form).then(res => {
          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      sendEmail(){
        let form = new FormData()
        form.append('Email', this.userEmail)
        form.append('Type', 6)
        sendAuthCode(form).then(res => {
          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      countDown(time) {
        if (time > 0) {
          this.isDisabled = true
          time -= 1
          this.sendTime = time
          setTimeout(() => {
            this.countDown(time)
          }, 1000)
        } else {
          this.sendTime = ''
          this.isDisabled = false
        }
      },
    },
  }
</script>
